export default __webpack_public_path__ + "static/media/arrowDownWhite.0af75267.svg";